import { ICache, InMemoryCache } from '@auth0/auth0-react';

// Shared in-memory Auth0 token cache. Passed to Auth0Provider so tokens are not
// persisted to localStorage, while still letting the app read the refresh token
// (needed to build the SSO credentials string) from the same instance.
export const authCache: ICache = new InMemoryCache().enclosedCache;
